/**
 * App Theme Configuration — Tensor Hive
 *
 * Robinhood-style palette: near-white pale backdrop, crisp black text,
 * one loud green accent (#00C805) doing all the work.
 *
 * Colors use HSL format: "hue saturation% lightness%"
 */

// Plus Jakarta Sans — friendly, rounded, fintech-consumer feel (Robinhood-adjacent)
const font = { url: 'https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400..800&display=swap', family: "'Plus Jakarta Sans', sans-serif" };

export const theme = {
  colors: {
    background: '204 60% 97%', // #f6fafe — pale near-white
    foreground: '222 20% 9%', // near-black
    card: '0 0% 100%',
    'card-foreground': '222 20% 9%',
    popover: '0 0% 100%',
    'popover-foreground': '222 20% 9%',
    primary: '122 100% 39%', // Robinhood green #00C805
    'primary-foreground': '0 0% 100%',
    secondary: '204 30% 94%',
    'secondary-foreground': '222 20% 9%',
    muted: '204 25% 93%',
    'muted-foreground': '215 15% 42%',
    accent: '122 70% 93%', // pale green tint
    'accent-foreground': '122 100% 24%',
    destructive: '0 72% 51%',
    'destructive-foreground': '0 0% 100%',
    border: '210 25% 88%',
    input: '210 25% 90%',
    ring: '122 100% 39%',
    link: '122 100% 33%',
    'link-hover': '122 100% 28%',
    button: '222 20% 9%', // near-black pill buttons/nav
    'button-foreground': '0 0% 100%',
    'button-border': '222 20% 16%',
    'button-hover': '122 100% 39%',
    'button-hover-foreground': '0 0% 100%',
    'button-hover-border': '122 100% 39%',
    'button-ring': '122 100% 39%',
    'chart-1': '122 100% 39%',
    'chart-2': '199 89% 48%',
    'chart-3': '38 92% 50%',
    'chart-4': '271 70% 60%',
    'chart-5': '340 75% 55%',
    'sidebar-background': '222 20% 9%',
    'sidebar-foreground': '204 30% 90%',
    'sidebar-primary': '122 100% 39%',
    'sidebar-primary-foreground': '0 0% 100%',
    'sidebar-accent': '222 20% 14%',
    'sidebar-accent-foreground': '204 30% 90%',
    'sidebar-border': '222 20% 18%',
    'sidebar-ring': '122 100% 39%',
  },
  font,
  radius: '1.1rem',
};
